// What the app SHOWS about Premium. The price actually CHARGED lives on the
// server in netlify/functions/_lib/plan.js. A test fails if they differ.
//
// Launch switch: set REACT_APP_PREMIUM_ENABLED=true (Netlify build env) only when
// payments are really ready. Until then the app shows "Coming Soon" + waitlist.
export const PLAN = {
  id: "premium_30d",
  name: "NORYQ Premium (30 days)",
  priceInr: 19,
  durationDays: 30,
};

export const PREMIUM_LIVE = process.env.REACT_APP_PREMIUM_ENABLED === "true";
